@if (error) {
  <div
    class="error-block"
    [ngClass]="['severity-' + error.severity, 'variant-' + variant]"
    [attr.role]="ariaRole"
    aria-atomic="true"
  >
    <div class="eb-head">
      <span class="eb-chip"><svg [lucideIcon]="error.glyph" aria-hidden="true"></svg></span>

      <div class="eb-text">
        <div class="eb-title">{{ error.title }}</div>
        <!-- Only the message scrolls. The title, the actions and the reference line stay put:
             they carry the remedy and the support handoff, so they must never scroll away. -->
        <div
          class="eb-body"
          #body
          [attr.tabindex]="bodyScrolls ? 0 : null"
          [attr.role]="bodyScrolls ? 'group' : null"
          [attr.aria-label]="bodyScrolls ? 'Error details' : null"
        >
          @if (error.detail) {
            <div class="eb-detail">{{ error.detail }}</div>
          }

          @if (issueRows.length) {
            <ul class="eb-issues">
              @for (item of issueRows; track itemTrackBy($index, item)) {
                <li>
                  <span>{{ item.reason }}</span>
                  @if (item.remedy) {
                    <a href="#" class="eb-remedy" (click)="onRemedy(item, $event)">{{ item.remedy.label }}</a>
                  }
                </li>
              }
            </ul>
          }
        </div>
      </div>

      @if (dismissible) {
        <button type="button" class="eb-close" (click)="onDismiss()" aria-label="Dismiss notification">
          <svg [lucideIcon]="dismissGlyph" aria-hidden="true"></svg>
        </button>
      }
    </div>

    @if (applicationRows.length) {
      <div class="eb-rows">
        @for (item of applicationRows; track itemTrackBy($index, item)) {
          <div class="eb-row" [class.is-ok]="item.ok">
            <svg [lucideIcon]="item.ok ? checkGlyph : error.glyph" aria-hidden="true"></svg>
            <div>
              @if (item.id) {
                <span class="eb-row-id">{{ item.id }}</span>
              }
              <span class="eb-row-reason">{{ item.reason }}</span>
              @if (item.remedy) {
                <a href="#" class="eb-remedy" (click)="onRemedy(item, $event)">{{ item.remedy.label }}</a>
              }
            </div>
          </div>
        }
      </div>
    }

    @if (error.actions.length) {
      <div class="eb-actions">
        @for (action of error.actions; track actionTrackBy($index, action)) {
          @if (action.href && !action.disabled) {
            <a
              class="eb-action"
              [class.quiet]="action.kind === 'quiet'"
              [href]="action.href"
              target="_blank"
              rel="noopener"
              (click)="onAction(action, $event)"
              >{{ action.label }}</a
            >
          } @else {
            <button
              type="button"
              class="eb-action"
              [class.quiet]="action.kind === 'quiet'"
              [disabled]="action.disabled || !!countdowns[action.id]"
              (click)="onAction(action, $event)"
            >
              @if (action.id === 'copy-details') {
                <svg [lucideIcon]="copied ? checkGlyph : copyGlyph" aria-hidden="true"></svg>
              }
              {{ action.id === 'copy-details' && copied ? 'Copied' : actionLabel(action) }}
            </button>
          }
        }
      </div>
    }

    @if (referenceLine) {
      <div class="eb-reference">{{ referenceLine }}</div>
    }
  </div>
}
